import { createHOCWithHookInside } from '../../hoc/createHOCWithHookInside';
import { usePurchaseMedia } from './usePurchaseMedia';

/**
 * @deprecated
 */
export const withPurchaseMedia = createHOCWithHookInside('withPurchaseMedia', usePurchaseMedia);
